import { render, staticRenderFns } from "./view-avatar.vue?vue&type=template&id=34cb5b53&"
import script from "./view-avatar.vue?vue&type=script&lang=js&"
export * from "./view-avatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports